import DOMPurify from "dompurify";

// Every HTML shown with v-safe-html goes through DOMPurify: notes, templates, AI output, patient answers.
// Formatting stays; scripts, event handlers and javascript: links go away.
export function sanitizeHtml(html) {
  if (html === null || html === undefined) return "";
  return DOMPurify.sanitize(String(html), { ADD_ATTR: ["target"] });
}

const render = (el, binding) => {
  if (binding.value === binding.oldValue && el.__safeHtmlSet) return;
  el.innerHTML = sanitizeHtml(binding.value);
  el.__safeHtmlSet = true;
};

export const safeHtmlDirective = { mounted: render, updated: render };
